import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledBox = styled.div`
@media screen and (max-width: ${ScreenSize.tablet}px) {
    &:nth-of-type(1) {
        margin-bottom: 20px;
    }
}
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        &:nth-of-type(1) {
            margin-bottom: 20px;
        }
    }
`;
